module.exports = __webpack_public_path__ + "static/media/atom.c5a1a5b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/atom.svg
// module id = 335
// module chunks = 0